if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;

        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (!this.form) return;
        if (!this.variantIdInput) return;
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.error = false;
        this.handleErrorMessage();
        this.setLoadingState(true);

        const formData = new FormData(this.form);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.error = true;

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.handleSoldOutState();

              return null;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            const addedProductTitle = this.cleanProductTitle(
              response.product_title || response.title || ''
            );

            return this.fetchCart().then((cart) => {
              return {
                cart: cart,
                addedProductTitle: addedProductTitle,
              };
            });
          })
          .then((result) => {
            if (!result || this.error) return;

            const cart = result.cart;
            const addedProductTitle = result.addedProductTitle;

            this.updateHeaderCartCount(cart.item_count || 0);

            if (typeof window.DFRefreshCartDrawer === 'function') {
              window.DFRefreshCartDrawer();
            }

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal && typeof quickAddModal.hide === 'function') {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.showMiniPopup(addedProductTitle);
                  }, 120);
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.showMiniPopup(addedProductTitle);
            }
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage('Non siamo riusciti ad aggiungere il capo al carrello. Riprova tra qualche istante.');
          })
          .finally(() => {
            this.setLoadingState(false);

            if (typeof CartPerformance !== 'undefined' && CartPerformance.measureFromEvent) {
              CartPerformance.measureFromEvent('add:user-action', event);
            }
          });
      }

      fetchCart() {
        return fetch(`${routes.cart_url}.js`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
        }).then((response) => response.json());
      }

      cleanProductTitle(title) {
        if (!title) return '';

        return title
          .replace(/\s+/g, ' ')
          .replace(/\s+è stato aggiunto al carrello\.?/gi, '')
          .replace(/aggiunto al carrello/gi, '')
          .trim();
      }

      showMiniPopup(productTitle) {
        const cleanTitle = this.cleanProductTitle(productTitle);

        if (typeof window.DFShowCartMiniPopup === 'function') {
          window.DFShowCartMiniPopup(cleanTitle);
          return;
        }

        console.log(
          cleanTitle
            ? `${cleanTitle} è stato aggiunto al carrello.`
            : 'Il capo è stato aggiunto al carrello.'
        );
      }

      updateHeaderCartCount(count) {
        document.querySelectorAll('[data-df-cart-count]').forEach((element) => {
          element.textContent = count;

          if (count > 0) {
            element.classList.remove('is-hidden');
          } else {
            element.classList.add('is-hidden');
          }
        });

        document.querySelectorAll('[data-df-cart-drawer-count]').forEach((element) => {
          element.textContent = count;
        });
      }

      setLoadingState(isLoading) {
        if (!this.submitButton) return;

        const spinner = this.querySelector('.loading__spinner');

        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');

          if (spinner) {
            spinner.classList.remove('hidden');
          }

          return;
        }

        this.submitButton.classList.remove('loading');

        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        }

        if (spinner) {
          spinner.classList.add('hidden');
        }
      }

      handleSoldOutState() {
        if (!this.submitButton) return;

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

        if (!soldOutMessage) return;

        this.submitButton.setAttribute('aria-disabled', 'true');

        if (this.submitButtonText) {
          this.submitButtonText.classList.add('hidden');
        }

        soldOutMessage.classList.remove('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }

          return;
        }

        this.submitButton.removeAttribute('disabled');

        if (this.submitButtonText && window.variantStrings) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        if (!this.form) return null;
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}